<template>
  <v-container fill height
    style="max-width: 100% !important;padding-top: 0;padding-left: 0;padding-bottom: 0;margin: 0;padding-right: 0;width: 100%;">
    <div v-if="back" v-on:click="backTo(true)" :style="this.$store.state.backButton">
      <v-btn :color="colorTheme" style="min-width: 28px !important;width: 48px;">
        <v-icon large left style="color: white;font-size: 30px;margin: 0;">mdi-arrow-left</v-icon>
      </v-btn>
    </div>
    <v-btn fab :style="this.$store.state.showVehTable" v-if="showButtonToTable">
      <v-icon :color="colorTheme"
        v-on:click="commandsCardOpen == false ? ButtonToTableC() : ButtonToTable()">mdi-chevron-up</v-icon>
    </v-btn>
    <div v-if="back" :style="this.$store.state.commandAndRepButton">
      <v-btn fab v-if="reportsView == false && showButtonToTable == false"
        style="min-width: 28px !important;width: 45px;height: 45px;bottom: 122%; right: 5%;margin-bottom: 7px;">
        <v-icon :color="colorTheme" v-on:click="showReports()">mdi-clipboard-text</v-icon>
      </v-btn>
      <v-btn fab v-if="commandsView == false && showButtonToTable == false"
        style="min-width: 28px !important;width: 45px;height: 45px;bottom: 122%; right: 5%;margin-bottom: 5px;">
        <v-icon :color="colorTheme" v-on:click="showCommands()">mdi-cellphone-nfc</v-icon>
      </v-btn>
    </div>
    <div :style="cardSize">
      <v-card id="changeCardSizeTracking" class="mx-auto theScrollTracking heightOfTrackingCard" max-width="640"
        style="border-radius: 10px 10px 0px 0px;pointer-events: initial;" v-if="vehiclesView" height="300">
        <v-card-title class="pt-0">
          <div class="line" v-on:click="iconUp ? extendedCard() : minimizeCard()"></div>
          <v-icon style="font-size: 30px;" v-on:click="tableToButton()">mdi-chevron-down</v-icon>
        </v-card-title>
        <v-row>
          <v-col cols="10">
            <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" :label="$t('search')" single-line
              hide-details solo flat></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="2" style="padding-left: 0;text-align: end;">
            <v-icon class="icon-size" style="padding-right: 20px;padding-top: 10px;" :color="colorTheme"
              v-on:click="refresh()">mdi-autorenew</v-icon>
          </v-col>
        </v-row>

        <v-divider></v-divider>
        <v-data-table :headers="headersTracking"
          :items="this.$store.state.radiusActive == false ? trackingList : markersInRadius" :search="search"
          item-key="DeviceIdAndNick" sort-by="DateServer" :sort-desc="true"
          :items-per-page="this.$store.state.trackingTable" :no-data-text="$t('noResults')"
          :loading="loadingTableInTracking" :loading-text="$t('loadingTextForTable')" class="tableTracking"
          mobile-breakpoint="0" :footer-props="this.$store.state.footerProps" :single-expand="true" show-expand
          :expanded.sync="expanded">
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-row>
                <v-col align="right" cols="12">
                  <v-btn text small :color="colorTheme" v-on:click="checkStatus(item)" class="regularText">{{
                    $t("checkStatus").toUpperCase() }}</v-btn>
                  <v-btn text small :color="colorTheme" v-on:click="openInMap(item, false)" class="regularText">{{
                    $t("centerOnMap").toUpperCase() }}</v-btn>
                </v-col>
              </v-row>
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">{{ $t("noResults") }} : "{{ search
            }}".</v-alert>
          <template v-slot:footer.page-text="items">{{ items.pageStart }} - {{ items.pageStop }}
            {{$t("of").toLowerCase()}} {{ items.itemsLength }}</template>
        </v-data-table>
      </v-card>
      <!--Estatus-->
      <v-card id="changeCardSizeTracking" class="mx-auto theScrollTracking heightOfTrackingCard" max-width="640"
        style="border-radius: 10px 10px 0px 0px;pointer-events: initial;" v-if="estatusView" height="300">
        <v-card-title class="pa-0">
          <div class="line" v-on:click="iconUp ? extendedCard() : minimizeCard()"></div>
          <v-icon style="font-size: 30px;" v-on:click="tableToButton()">mdi-chevron-down</v-icon>
        </v-card-title>
        <v-row>
          <v-icon class="icon-size-subtitle ml-3" id="sizeChev" v-on:click="backTo(true)">mdi-chevron-left</v-icon>
          <span class="subtitle2Text" style="float: left;">{{ topData[0].value }}</span>
        </v-row>
        <v-card-text class="pt-1 pb-0 text-start">
          <p class="regularText ma-0">{{ topData[1].value }}</p>
          <p class="regularText ma-0">{{ topData[2].value }}</p>
          <p class="regularText ma-0">{{ topData[3].value }}</p>
        </v-card-text>

        <v-card-actions class="py-0">
          <div style="display: contents;">
            <v-chip class="ma-2" v-on:click="lockCommand(false, true, 'POS')" color="primary" outlined pill>
              <v-icon class="icon-size">mdi-map-marker</v-icon>
              <p class="regularText mb-0" v-if="this.$store.state.showTxtOp == true">{{ $t("position") }}</p>
            </v-chip>

            <v-chip v-on:click="lockCommand(false, true, 'LOCKENGINE')" class="ma-2" color="primary" outlined pill>
              <v-icon class="icon-size">mdi-lock</v-icon>
              <p class="regularText mb-0" v-if="this.$store.state.showTxtOp == true">{{ $t("engine") }}</p>
            </v-chip>

            <v-chip v-on:click="showReports()" class="ma-2" color="primary" outlined pill>
              <v-icon class="icon-size">mdi-clipboard-clock-outline</v-icon>
              <p class="regularText mb-0" v-if="this.$store.state.showTxtOp == true">{{ $t("activity") }}</p>
            </v-chip>

            <v-chip v-on:click="openInMap('', true)" class="ma-2" color="primary" outlined pill>
              <v-icon class="icon-size">mdi-target</v-icon>
            </v-chip>
          </div>
        </v-card-actions>
        <div class="pa-0">
          <v-tabs v-model="tab" fixed-tabs>
            <v-tab href="#tab-1" class="subtitle3Text">{{ $t("status").toUpperCase() }}</v-tab>
            <v-tab href="#tab-2" class="subtitle3Text">{{ $t("vehicle").toUpperCase() }}</v-tab>
            <v-tabs-items v-model="tab">
              <v-tab-item value="tab-1">
                <div :style="this.$store.state.styleText">
                  <!-- Conexion -->
                  <v-row class="subtitle4Text">{{ $t("connection").toUpperCase() }}</v-row>
                  <v-row>
                    <template v-for="(item, index) in connectionVeh">
                      <v-col cols="12" lg="6" md="6" sm="6" v-bind:key="index" class="regularText pb-0 pt-1">
                        <v-icon style="font-size: 17px;margin: 5px;" left
                          :color="item.value ? '#8FAE2D' : '#929292'">mdi-check-circle</v-icon>
                        {{ item.title }}
                      </v-col>
                    </template>
                  </v-row>
                  <!--Referencia geografica -->
                  <v-row class="subtitle4Text py-2">{{ $t("geoReference").toUpperCase() }}</v-row>
                  <div>
                    <template v-for="(item, index) in refGeo">
                      <v-row v-bind:key="index">
                        <v-col cols="2" lg="1" md="1" sm="2">
                          <v-icon style="font-size: 17px;margin: 5px;color:#8FAE2D;" left>{{item.icon}}</v-icon>
                        </v-col>
                        <v-col cols="10" lg="11" md="11" sm="10">
                          <v-row style="font-size: 0.80rem;">{{ item.title }}</v-row>
                          <v-row style="font-size: 0.78rem;">{{ item.value }}</v-row>
                        </v-col>
                      </v-row>
                    </template>
                  </div>
                  <!--Entradas / salidas-->
                  <v-row class="subtitle4Text pt-2">{{ $t("iO").toUpperCase() }}</v-row>
                  <v-row>
                    <template v-for="(item, index) in inAndOutVeh">
                      <v-col cols="12" lg="6" md="6" sm="6" v-bind:key="index" class="regularText pb-0 pt-1">
                        <v-icon style="font-size: 17px;margin: 5px;" left
                          :color="item.value ? '#8FAE2D' : '#929292'">mdi-check-circle</v-icon>
                        {{ item.title }}
                      </v-col>
                    </template>
                  </v-row>
                </div>
              </v-tab-item>
              <v-tab-item value="tab-2">
                <div :style="this.$store.state.styleText">
                  <!-- Vehiculo -->
                  <v-row class="subtitle4Text">{{ $t("vehAttributes").toUpperCase() }}</v-row>
                  <div class="mt-3">
                    <template v-for="(item, index) in vehicleData">
                      <v-row v-bind:key="index">
                        <v-col cols="2" lg="1" md="1" sm="2">
                          <v-icon style="font-size: 17px;margin: 5px;color:#8FAE2D;" left>{{item.icon}}</v-icon>
                        </v-col>
                        <v-col cols="10" lg="11" md="11" sm="10">
                          <v-row style="font-size: 0.80rem;">{{ item.title }}</v-row>
                          <v-row style="font-size: 0.78rem;">{{ item.value }}</v-row>
                        </v-col>
                      </v-row>
                    </template>
                  </div>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </div>
      </v-card>

      <!--REPORTS VIEW-->
      <v-card id="changeCardSizeTracking" class="mx-auto theScrollTracking heightOfTrackingCard" max-width="640"
        v-if="reportsView" style="border-radius: 10px 10px 0px 0px;pointer-events: initial;" height="300">
        <v-card-title class="pt-0">
          <div class="line" v-on:click="iconUp ? extendedCard() : minimizeCard()"></div>
          <v-icon style="font-size: 30px;" v-on:click="tableToButtonR()">mdi-chevron-down</v-icon>
        </v-card-title>
        <v-row class="mb-2 text-start">
          <v-col cols="12" class="py-0">
            <v-icon class="icon-size-subtitle ml-3" id="sizeChev" v-on:click="showReports()">mdi-chevron-left</v-icon>
            <v-icon class="icon-size-subtitle mr-1" :color="colorTheme" left>mdi-clipboard-text</v-icon>
            <span class="subtitle2Text">{{ $t("reports").toUpperCase() }}</span>
            <span class="subtitle2Text mr-5" style="float: right;">{{ reportsDeviceIdAndNick }}</span>
          </v-col>
        </v-row>
        <v-progress-linear height="2" :color="colorTheme" :indeterminate="indeterminateReport"
          v-model="valueDeterminate"></v-progress-linear>
        <div style="padding: 5%;">
          <v-row class="subtitle4Text mb-3" style="padding-left: 7px;">
            {{ $t("preferences").toUpperCase() }}
            <v-spacer></v-spacer>
            <v-icon large left :color="colorTheme" style="font-size: 22px;">mdi-check</v-icon>
          </v-row>
          <v-row class="regularText mb-2" style="padding-left: 7px;">
            {{ $t("periodTitle") }}
            <v-spacer></v-spacer>
            <v-btn class="regularText" style="height: 25px;" v-on:click="showCalendarFunction()" rounded
              :color="colorTheme" outlined>
              <v-icon large left :color="colorTheme" style="font-size: 22px;">mdi-calendar</v-icon>
              {{periodTracking}}
            </v-btn>
          </v-row>
          <v-row class="regularText mb-3" style="padding-left: 7px;">
            {{ $t("type") }}
            <v-spacer></v-spacer>
            <v-btn class="regularText" style="height: 25px;" rounded :color="colorTheme" outlined>{{
              $t("recentActivity").toUpperCase() }}</v-btn>
          </v-row>
          <v-row class="subtitle4Text mb-1" style="padding-left: 7px;">
            <v-icon class="icon-size" left :color="colorTheme">mdi-clipboard-text</v-icon>
            {{ $t("recentActivity").toUpperCase() }}
            <v-spacer></v-spacer>
            <v-icon large left :color="colorTheme" style="font-size: 22px;"
              v-on:click="refreshReport()">mdi-autorenew</v-icon>
          </v-row>
          <v-divider class="mb-3"></v-divider>
          <v-row class="regularText pa-1" v-if="this.$store.state.noActivity">
            <v-icon class="icon-size mr-1">mdi-map-marker-question</v-icon>
            {{$t("noActivityData")}}
          </v-row>
          <v-row v-else>
            <template v-for="(item, index) in activityList">
              <v-col cols="12" sm="12" v-bind:key="index">
                <v-row>
                  <v-col cols="1">
                    <v-icon class="icon-size" left :color="item.State == 2 ? colorTheme : '#929292'">mdi-circle</v-icon>
                  </v-col>

                  <v-col cols="8" style="font-size: 13px;text-align: justify;padding-left: 25px;">
                    <v-row style="font-weight: bolder; font-size: 0.84rem;">{{ item.VehicleState }}</v-row>
                    <v-row class="regularText">{{ item.FormattedDate }}</v-row>
                    <v-row>
                      <span class="regularText" style="cursor:pointer; text-decoration:underline; color:#6ca3ff;"
                        v-on:click="getReference(item)">{{ item.Address }}</span>
                    </v-row>
                    <v-row class="regularText" v-if="item.State == 2">{{ $t("distance") }}: {{ item.Distance }}</v-row>
                  </v-col>

                  <v-col cols="3" style="font-size:0.75rem;">{{ item.Duration }}</v-col>
                  <v-divider></v-divider>
                </v-row>
              </v-col>
            </template>
          </v-row>
        </div>
      </v-card>

      <!--COMMANDS VIEW-->
      <v-card class="mx-auto" max-width="640" v-if="commandsView"
        style="border-radius: 10px 10px 0px 0px;pointer-events: initial;height:100%;">
        <v-card-title class="pt-0">
          <div class="line" v-on:click="iconUp ? extendedCard() : minimizeCard()"></div>
          <v-icon style="font-size: 30px;" v-on:click="tableToButtonC()">mdi-chevron-down</v-icon>
        </v-card-title>
        <v-row class="mb-2 text-start">
          <v-col cols="12" class="py-0">
            <v-icon class="icon-size-subtitle ml-3" id="sizeChev" v-on:click="showCommands()">mdi-chevron-left</v-icon>
            <v-icon class="icon-size-subtitle mr-1" :color="colorTheme" left>mdi-cellphone-nfc</v-icon>
            <span class="subtitle2Text">{{ $t("commands").toUpperCase() }}</span>
            <span class="subtitle2Text mr-5" style="float: right;">{{ reportsDeviceIdAndNick }}</span>
          </v-col>
        </v-row>
        <v-progress-linear height="2" :color="colorTheme" v-model="valueDeterminate"></v-progress-linear>
        <v-card-text style="flex-grow: 1;padding: 25px 20px 20px; height: 75%; overflow: auto scroll;">
          <v-row>
            <v-autocomplete :items="commandsList" item-text="command" item-value="id" v-model="commandSelected"
              :search-input.sync="searchCommand" :label="$t('selectCommand')" dense outlined :color="colorTheme"
              clearable>
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t("noResults") }} : "{{ searchCommand }}".</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>
            <v-row style="display: contents;" v-if="showCallParams">
              <v-col lg="12" md="12" sm="12" cols="12" style="text-align: initial;padding-top: 0;">
                <span>Parametros a enviar</span>
              </v-col>
              <v-row style="display: contents;">
                <v-col lg="6" md="12" sm="12" cols="12" style="padding-bottom: 0;">
                  <v-select :label="$t('callBy')" :items="listCallCommand" item-text="Name" item-value="Id"
                    :color="colorTheme" v-model="CallBy" outlined required></v-select>
                </v-col>
                <v-col lg="6" md="12" sm="12" cols="12" style="padding-bottom: 0;">
                  <v-text-field :label="$t('phone')" v-model="Phone" :rules="PhoneRules" :color="colorTheme" outlined
                    required :disabled="disablePhone"></v-text-field>
                </v-col>
              </v-row>
              <v-col lg="12" md="12" sm="12" style="padding-top: 0;">
                <v-checkbox v-model="speakerOn" :color="colorTheme" style="margin-top: 0; padding: 0; height: 32px;">
                  <template v-slot:label>
                    <div>{{ $t("speakerOn") }}</div>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
            <v-btn class="regulartext white--text" :color="colorTheme"
              v-on:click="lockCommand(false, true, commandSelected)" style="width: 100%;height: 38px;">{{
              $t("sendCommand").toUpperCase() }}</v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
    <v-card id="menuTracking">
      <ul>
        <li v-if="vehiclesView == true && this.$store.state.production == false" class="menu-item"
          v-on:click="radius()">
          <v-icon class="pr-3 pl-2" style="font-size: 15px;">mdi-map-marker-radius</v-icon>
          {{ $t("searchVehicles") }}
        </li>
        <li v-if="commandsView == false" class="menu-item" v-on:click="showCommands()">
          <v-icon class="pr-3 pl-2" style="font-size: 15px;">mdi-cellphone-nfc</v-icon>
          {{ $t("sendCommand") }}
        </li>
        <li v-if="reportsView == false" class="menu-item" v-on:click="showReports()">
          <v-icon class="pr-3 pl-2" style="font-size: 15px;">mdi-clipboard-text</v-icon>
          {{ $t("seeAct") }}
        </li>
        <li v-if="estatusView == false" class="menu-item" v-on:click="checkStatus()">
          <v-icon class="pr-3 pl-2" style="font-size: 15px;">mdi-card-bulleted-settings-outline</v-icon>
          {{ $t("seeStatus") }}
        </li>
      </ul>
    </v-card>
    <v-card id="menuSearchVehT">
      <div v-if="this.$store.state.production == false" class="menu-item" v-on:click="radius()">
        <v-icon class="pr-3 pl-2" style="font-size: 15px;">mdi-map-marker-radius</v-icon>
        {{ $t("searchVehicles") }}
      </div>
    </v-card>
    <div id="trackingMap" style="width: 100%; height: 100%; position: absolute;"></div>
    <v-overlay :absolute="true" v-model="sendingCommand" style="z-index: 8;">
      <v-card width="300">
        <v-card-text v-if="!showMsgT" style="padding-top: 20px; text-align: -webkit-center;">
          {{ $t("await") }}
          <v-progress-circular class="mb-0" :size="70" :width="4" indeterminate :color="colorTheme"
            style="display: flex;"></v-progress-circular>
        </v-card-text>

        <v-card-text v-else style="padding-top: 20px; text-align: -webkit-center;">
          {{ titleCommand + ": " + commandName }}
          <br />
          <p style="font-weight: bolder;" v-if="responseTexto">{{responseText}}</p>
          <v-progress-circular class="mb-0" :size="70" :width="4" :value="100" :color="colorTheme"
            style="display: flex;">
            <v-icon v-if="!failedCommand" size="50" :color="colorTheme">mdi-check</v-icon>
            <v-icon v-else size="50" :color="colorTheme">mdi-close</v-icon>
          </v-progress-circular>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn v-if="showMsgT" :color="colorTheme" text v-on:click="closeOverlay(false)">
            {{
            $t("accept").toUpperCase()
            }}
          </v-btn>
          <v-btn v-else :color="colorTheme" text v-on:click="closeOverlay(true)">
            {{
            $t("cancel").toUpperCase()
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-overlay>
    <!--Confirmar commando-->
    <v-overlay :absolute="true" v-model="lockEngine" style="z-index: 8;">
      <v-card width="300">
        <v-card-text style="padding-top: 20px; text-align: -webkit-center;">{{ $t("confirmCommand") + ": "+
          commandName}}</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn :color="colorTheme" text v-on:click="lockCommand(false, false, commandToSend)">
            {{
            $t("cancel").toUpperCase()
            }}
          </v-btn>
          <v-btn :color="colorTheme" text v-on:click="lockCommand(true, false, commandToSend)">
            {{
            $t("accept").toUpperCase()
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-overlay>
    <!--CALENDAR-->
    <v-dialog v-model="calendarTime" max-width="600">
      <v-container>
        <calendarTime></calendarTime>
      </v-container>
    </v-dialog>
    <v-card id="sliderTracking" width="300">
      <v-col cols="12" style="text-align: end;" class="pb-6">
        <v-icon id="divDraggable" style="font-size: 21px;cursor:pointer;" class="pr-1" :color="colorTheme"
          v-on:click="draggableClicked()">mdi-drag-variant</v-icon>
        <v-icon style="font-size: 21px;" :color="colorTheme" v-on:click="refresh()">mdi-trash-can-outline</v-icon>
      </v-col>
      <v-col cols="12" class="pb-0">
        <v-slider dense v-model="slider" thumb-label="always" max="300" :color="colorTheme">
          <template #append>{{ SelectedDistance }}</template>
          <template #prepend>{{ SelectedDistance }}</template>
        </v-slider>
      </v-col>
    </v-card>
  </v-container>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "tracking",
  components: {
    calendarTime: () => import("@/components/calendarTime")
  },
  data() {
    return {
      search: "",
      tab: null,
      text: "HOLA",
      cardSize: "",
      commonCardSize:
        "pointer-events: none;position: fixed;bottom: 0;z-index: 8;width: 100%;padding: 2px;padding-bottom: 0 !important;",
      iconUp: true,
      vehiclesView: true,
      estatusView: false,
      commandsView: false,
      reportsView: false,
      back: false,
      commands: [],
      commandSelected: null,
      searchCommand: null,
      sendingCommand: false,
      lockEngine: false,
      iconListVeh: true,
      showButtonToTable: false,
      reportCardOpen: true,
      commandsCardOpen: true,
      commandToSend: "",
      commandName: "",
      reportsDeviceIdAndNick: "",
      PhoneRules: [v => !!v || this.$t("required")],
      CallBy: 0,
      Phone: "",
      speakerOn: false,
      disablePhone: false,
      showCallParams: false,
      selectDistance: [
        { value: 5 },
        { value: 10 },
        { value: 30 },
        { value: 50 },
        { value: 100 },
        { value: 150 },
        { value: 200 },
        { value: 250 }
      ],
      distance: "",
      distanceModel: "",
      slider: 150,
      isRadius: false,
      isDraggable: false,
      expanded: [],
    };
  },
  created() {
    this.$store.commit("selectionNames");
    this.cardSize = this.commonCardSize;
    this.$store.commit("setTitle", this.$i18n.t("tracking"));
    this.$store.state.SelectedDistance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");
    this.distance =
      localStorage.getItem("distanceForTracking") == undefined ||
      localStorage.getItem("distanceForTracking") == null
        ? 150
        : localStorage.getItem("distanceForTracking");
  },
  mounted() {
    var initialSettings = JSON.parse(localStorage.getItem("initialSettings"));

    this.$store.dispatch("startTrackingMap", !initialSettings);
    this.$store.state.trackingFirstTime = true;
    var defaultDate = moment().format("L");
    var todaysDate = defaultDate;
    if (i18n.locale == "en") {
      todaysDate = moment(defaultDate).format("MM/DD/YYYY");
    }
    this.$store.state.periodTracking =
      todaysDate + " 00:00 - " + todaysDate + " 23:59";
    if (this.$store.state.windowSize.width < 530) {
      var element = document.getElementById("changeCardSizeTracking");
      element.classList.remove("heightOfTrackingCard");
      this.$store.state.trackingTable = 3;
      this.$store.state.backButton =
        "position: absolute;z-index: 8; margin-top: 17%;margin-left: 10px;";
      this.$store.state.commandAndRepButton =
        "position: absolute;z-index: 8; top: 35%;right: 3%;display:grid;";
      this.$store.state.footerProps = {
        "items-per-page-options": [3, 5],
        "items-per-page-text": this.$i18n.t("rows")
      };
      this.$store.state.showVehTable =
        "z-index: 8;width: 48px;position: absolute;left: 50%;transform: translate(-50%, -50%);margin: 0px auto 0px 0px;bottom: 0% !important;min-width: 28px !important;";
      // this.$store.state.styleText =
      //   "flex-grow: 1; padding: 20px; overflow: auto; padding-top: 10px; overflow-y: scroll; max-height: calc(100vh - 750px);min-height: calc(100vh - 684px);font-size: 13px;text-align: initial;";
    } else {
      this.$store.state.trackingTable = 5;
      this.$store.state.backButton =
        "position: absolute;z-index: 8; margin-top: 80px;margin-left: 15px;";
      this.$store.state.commandAndRepButton =
        "position: absolute;z-index: 8; margin-top: 130px;right: 6px;display:grid;";
      this.$store.state.footerProps = {
        "items-per-page-options": [3, 5, 10],
        "items-per-page-text": this.$i18n.t("rows")
      };
      this.$store.state.showVehTable =
        "z-index: 8;width: 48px;position: absolute;left: 50%;transform: translate(-50%, -50%);margin: 0px auto 0px 0px;bottom: 0% !important;min-width: 28px !important;";
      this.$store.state.styleText =
        "flex-grow: 1; padding: 20px; overflow: auto; padding-top: 10px; overflow-y: scroll; max-height: calc(100vh - 750px);min-height: calc(100vh - 751px);font-size: 13px;text-align: initial;";
    }
    this.dragToolBox();
  },
  watch: {
    trackingChange() {
      this.$store.commit("trackingChange", false);
      this.backTo(false);
    },
    commandSelected() {
      if (this.commandSelected == "961c9566-6c9a-489c-94f7-96c2f5258e1f") {
        this.showCallParams = true;
      } else {
        this.showCallParams = false;
      }
    },
    slider(rad) {
      if (this.$store.state.circleTracking != null) {
      var toolBox = document.getElementById("sliderTracking");
      this.$store.state.givenRadius = rad * 1000;
      if (this.$store.state.SelectedDistance != "Km") {
        this.$store.state.givenRadius = (rad * 1609.344).toFixed(3).replace(/\.000$/, "");
        this.$store.state.givenRadius = parseFloat(this.$store.state.givenRadius);
      }
      this.$store.state.circleTracking.setRadius(this.$store.state.givenRadius);
      this.$store.state.markersInRadius = [];
      var trackingList = this.$store.state.trackingList;
      //el slider busca en la lista de vehiculos formateada por theTrackingList que se obtuvo del ws
      for (var i = 0; i < trackingList.length; i++) {
        //la api de google maps calcula la distancia en metros
        if (
          google.maps.geometry.spherical.computeDistanceBetween(
            this.$store.state.referencePoint,
            new google.maps.LatLng(
              trackingList[i].Location.Lat,
              trackingList[i].Location.Lon
            )
          ) <= this.$store.state.givenRadius
        ) {
          //sirve para no modificar la lista de vehiculos formateada por theTrackingList que se obtuvo del ws
          //y solo mostrar los vehiculos dentro del radio
          this.$store.state.markersInRadius.push(trackingList[i]);
        }
      }

      //si se ha usado draggable la toolbox se queda donde esta, sino se ha usado el draggable la toolbox se acomoda debajo del circulo
      if (this.isDraggable == false) {
        //obtengo coordenadas a partir de las coordenadas del referencePoint, los metros del radio y a 180 grados 
        //ya que google maps cuenta los grados como el reloj y ocupo 180 grados para ubicarme debajo del circulo
        var newlatLng = google.maps.geometry.spherical.computeOffset(this.$store.state.referencePoint,this.$store.state.givenRadius,180);
        //creo overlay para obtener los pixeles a partir de coordenadas
        if (this.$store.state.overlayToolBox == null) {
          this.$store.state.overlayToolBox = new google.maps.OverlayView();
          this.$store.state.overlayToolBox.draw = function() {};
          this.$store.state.overlayToolBox.setMap(this.$store.state.insideTrackingMap);
        }
        var myPixels = this.$store.state.overlayToolBox.getProjection().fromLatLngToContainerPixel(newlatLng);
        //acomodo la toolbox
        toolBox.style.left = myPixels.x + "px";
        toolBox.style.top = myPixels.y + 20 + "px";
        toolBox.style.display = "block";
        console.log(myPixels);
      }
      
      this.$store.dispatch("setTrackingMap", {
        listOfVeh: this.$store.state.markersInRadius,
        isRadius: true
      });
      this.$store.state.radiusActive = true;
    }
    }
  },
  computed: {
    ...mapState([
      "colorTheme",
      "headersTracking",
      "trackingList",
      "test",
      "loadingTableInTracking",
      "valueDeterminate",
      "responseActivity",
      "calendarTime",
      "titleCommand",
      "failedCommand",
      "commandsList",
      "setResponse",
      "showMsgT",
      "indeterminateReport",
      "noActivity",
      "trackingChange",
      "markersInRadius"
    ]),
    personalization: {
      get: function() {
        return this.$store.state.personalization;
      },
      set: function() {}
    },
    activityList: {
      get: function() {
        return this.$store.state.activityList;
      },
      set: function() {}
    },
    periodTracking: {
      get: function() {
        return this.$store.state.periodTracking;
      },
      set: function() {}
    },
    responseTexto: {
      get: function() {
        return this.$store.state.responseTexto;
      },
      set: function() {}
    },
    responseText: {
      get: function() {
        return this.$store.state.responseText;
      },
      set: function() {}
    },
    refGeo: {
      get: function() {
        return this.$store.state.refGeo;
      },
      set: function() {}
    },
    connectionVeh: {
      get: function() {
        return this.$store.state.connectionVeh;
      },
      set: function() {}
    },
    inAndOutVeh: {
      get: function() {
        return this.$store.state.inAndOutVeh;
      },
      set: function() {}
    },
    vehicleData: {
      get: function() {
        return this.$store.state.vehicleData;
      },
      set: function() {}
    },
    topData: {
      get: function() {
        return this.$store.state.topData;
      },
      set: function() {}
    },
    windowSize: {
      get: function() {
        return this.$store.state.windowSize.width;
      },
      set: function() {}
    },
    listCallCommand: {
      get: function() {
        return this.$store.state.listCallCommand;
      },
      set: function() {}
    },
    SelectedDistance: {
      get: function() {
        return this.$store.state.SelectedDistance;
      },
      set: function() {}
    }
  },
  methods: {
    showCalendarFunction() {
      this.$store.commit("calendarTime", true);
    },
    extendedCard() {
      this.iconUp = false;
      if (this.$store.state.windowSize.width < 530) {
        this.$store.state.trackingTable = 5;
        this.$store.state.styleText =
          "flex-grow: 1; padding: 20px; overflow: auto; padding-top: 10px; overflow-y: scroll;font-size: 13px; min-height: calc(100vh - 690px); text-align: initial; max-height: calc(100vh - 367px);";
      } else {
        this.$store.state.trackingTable = 10;
        this.$store.state.styleText =
          "flex-grow: 1; padding: 20px; overflow: auto; padding-top: 10px; overflow-y: scroll;font-size: 13px; min-height: calc(100vh - 690px); text-align: initial; max-height: calc(100vh - 384px);";
      }

      if (this.vehiclesView == true) {
        this.cardSize = this.commonCardSize;
      } else {
        this.cardSize = this.commonCardSize + "height: 85%;";
      }
    },
    minimizeCard() {
      this.iconUp = true;
      if (this.$store.state.windowSize.width < 530) {
        this.$store.state.trackingTable = 3;
        this.$store.state.styleText =
          "flex-grow: 1; padding: 20px; overflow: auto; padding-top: 10px; overflow-y: scroll; max-height: calc(100vh - 750px);min-height: calc(100vh - 684px);  text-align: initial;";
      } else {
        this.$store.state.trackingTable = 5;
        this.$store.state.styleText =
          "flex-grow: 1; padding: 20px; overflow: auto; padding-top: 10px; overflow-y: scroll; max-height: calc(100vh - 750px);min-height: calc(100vh - 751px);  text-align: initial;";
      }

      if (this.vehiclesView == true) {
        this.cardSize = this.commonCardSize;
      } else {
        this.cardSize = this.commonCardSize + "height: 46%;";
      }
    },
    async checkStatus(item) {
      this.$store.commit("statusViewVisible", true);
      this.$store.commit("reportViewVisible", false);
      if (item == undefined) {
        item = this.$store.state.selectedVeh;
      }
      var contextMenu = document.getElementById("menuTracking");
      contextMenu.style.display = "none";

      let status = {
        IdReporte: "NA",
        DeviceId: item.MovilId,
        Lat: item.Location.Lat,
        Lon: item.Location.Lon,
        DateTimestamp: item.TimeStampGps
      }

      let validateReference = this.$store.getters.isValidReferenceValue(item.Address);
      if (validateReference == false) {
        let reference = null;

        try {
          reference = await this.$store.dispatch("getReferenceData", status);
        } catch (e) {
          reference = null;
        }

        reference = reference == null ? i18n.t("notAvailable") : reference;
        item.Address = reference;
      }

      this.setTrackingData(item);
    },

    setTrackingData(item) {
      this.$store.state.fleetLastPositionSave = item;
      this.$store.commit("setItemsTracking", item);
      this.$store.state.selectedVeh = item;

      var centerLatLng = {
        lat: item.Location.Lat,
        lng: item.Location.Lon
      };
      this.$store.dispatch("goToMarker", centerLatLng);
      this.$store.state.selectedVehLatLng = centerLatLng;
      this.vehiclesView = false;
      this.estatusView = true;
      this.cardSize = this.commonCardSize + "height: 46%;";
      if (this.$store.state.windowSize.width < 530) {
        this.$store.state.styleText =
          "flex-grow: 1; padding: 20px; overflow: auto; padding-top: 10px; overflow-y: scroll; max-height: calc(100vh - 750px);min-height: calc(100vh - 684px);font-size: 13px;text-align: initial;";
      } else {
        this.$store.state.styleText =
          "flex-grow: 1; padding: 20px; overflow: auto; padding-top: 10px; overflow-y: scroll; max-height: calc(100vh - 750px);min-height: calc(100vh - 751px);font-size: 13px;text-align: initial;";
      }
      this.back = true;
    },
    openInMap(item, checkStatus) {
      var centerLatLng = {};
      if (checkStatus) {
        var latLangVal = this.$store.state.refGeo[2].value.split(" ");
        centerLatLng = {
          lat: parseFloat(latLangVal[0]),
          lng: parseFloat(latLangVal[1])
        };

      } else {
        centerLatLng = {
          lat: item.Location.Lat,
          lng: item.Location.Lon
        };
      }

      this.$store.dispatch("goToMarker", centerLatLng);
    },
    sendCommand(type) {
      var commandId = "",
        params = "",
        vehicleId = this.$store.state.selectedVeh.MovilId;
      commandId = type;
      this.sendingCommand = true;
      if (type == "POS") {
        commandId = "9dbb6596-b45a-4f08-a69f-9b028456391b";
      } else if (type == "LOCKENGINE") {
        commandId = "26c803ee-b0c3-4535-b14f-02352b349cef";
      } else if (type == "961c9566-6c9a-489c-94f7-96c2f5258e1f") {
        var speaker = this.speakerOn == true ? 1 : 0;
        var valid = this.ValidatePhone(this.Phone);
        if (valid && this.Phone.length > 9) {
          params = this.CallBy + "," + this.Phone + "," + speaker;
        } else {
          this.sendingCommand = false;
          this.$store.commit("snackbar", {
            snackbar: true,
            text: i18n.t("invalidPhone")
          });
        }
      }
      this.$store.dispatch("sencCommandTracking", {
        vehicleId: vehicleId,
        commanId: commandId,
        parameters: params
      });
    },
    ValidatePhone(number) {
      if (number.match(/^\d+/)) {
        return true;
      }
      return false;
    },
    backTo(setBounds) {
      this.$store.commit("statusViewVisible", false);
      this.$store.commit("reportViewVisible", false);
      this.$store.commit("cleanClustersAndMarkersPolyline");
      if (this.$store.state.windowSize.width < 530) {
        var element = document.getElementById("changeCardSizeTracking");
        element.classList.remove("heightOfTrackingCard");
      }
      this.$store.dispatch("fleetLastPosition");
      //  console.log(this.$store.state.refGeo);
      if (setBounds) this.$store.dispatch("setBounds");
      this.vehiclesView = true;
      this.reportsView = false;
      this.commandsView = false;
      this.estatusView = false;
      this.back = false;
      this.cardSize = this.commonCardSize;
    },
    showReports: async function() {
      var contextMenu = document.getElementById("menuTracking");
      contextMenu.style.display = "none";
      this.reportsView = !this.reportsView;
      this.$store.commit("cleanClustersAndMarkersPolyline");
      if (this.reportsView) {
        this.cardSize = this.commonCardSize + "height: 46%;";
        this.$store.commit("reportViewVisible", true);
        this.$store.commit("statusViewVisible", false);
        this.reportsDeviceIdAndNick = this.$store.state.selectedVeh.DeviceIdAndNick;
        await this.$store.dispatch(
          "activityOfVehicle",
          this.$store.state.selectedVeh
        );
        this.commandsView = false;
        this.estatusView = false;
        this.vehiclesView = false;
      } else if (this.reportsView == false && this.back == false) {
        this.$store.commit("reportViewVisible", false);
        this.$store.commit("statusViewVisible", false);
        this.cardSize = this.commonCardSize;
        this.commandsView = false;
        this.estatusView = false;
        this.vehiclesView = true;
      } else if (this.reportsView == false && this.back == true) {
        this.$store.commit("reportViewVisible", false);
        this.$store.commit("statusViewVisible", true);
        if (this.$store.state.windowSize.width < 530) {
          this.$store.state.styleText =
            "flex-grow: 1; padding: 20px; overflow: auto; padding-top: 10px; overflow-y: scroll; max-height: calc(100vh - 750px);min-height: calc(100vh - 684px);font-size: 13px;text-align: initial;";
        } else {
          this.$store.state.styleText =
            "flex-grow: 1; padding: 20px; overflow: auto; padding-top: 10px; overflow-y: scroll; max-height: calc(100vh - 750px);min-height: calc(100vh - 751px);font-size: 13px;text-align: initial;";
        }
        this.estatusView = true;
      }
    },
    showCommands() {
      var contextMenu = document.getElementById("menuTracking");
      contextMenu.style.display = "none";
      this.commandsView = !this.commandsView;
      this.$store.commit("cleanClustersAndMarkersPolyline");
      if (this.commandsView) {
        this.reportsDeviceIdAndNick = this.$store.state.selectedVeh.DeviceIdAndNick;
        this.cardSize = this.commonCardSize + "height: 46%;";
        this.$store.commit("statusViewVisible", false);
        this.$store.commit("reportViewVisible", false);
        this.reportsView = false;
        this.estatusView = false;
        this.vehiclesView = false;
      } else if (this.commandsView == false && this.back == false) {
        this.$store.commit("statusViewVisible", false);
        this.$store.commit("reportViewVisible", false);
        this.cardSize = this.commonCardSize;
        this.commandsView = false;
        this.estatusView = false;
        this.vehiclesView = true;
      } else if (this.commandsView == false && this.back == true) {
        this.$store.commit("statusViewVisible", true);
        this.$store.commit("reportViewVisible", false);
        this.$store.state.styleText =
          "flex-grow: 1; padding: 20px; overflow: auto; padding-top: 10px; overflow-y: scroll; max-height: calc(100vh - 750px);min-height: calc(100vh - 751px);font-size: 13px;text-align: initial;";
        this.estatusView = true;
      }
    },
    closeOverlay(cancel) {
      this.sendingCommand = false;
      this.$store.commit("showMsgT", false);
      if (cancel) {
        this.$store.dispatch("cancelCommand");
      }
    },
    lockCommand(accept, open, command) {
      if (command != "POS") {
        this.lockEngine = open;
      }
      this.commandToSend = command;

      if (command == "POS") {
        this.commandName = this.$t("updatePosition");
      } else if (command == "LOCKENGINE") {
        this.commandName = this.$t("lockEngine");
      } else {
        var item = this.commandsList.find(item => item.id === command);
        this.commandName = item.command;
      }
      if (accept || command == "POS") {
        this.$store.state.responseTexto = false;
        this.sendCommand(this.commandToSend);
      }
    },
    tableToButton() {
      if (this.back == false) {
        this.vehiclesView = false;
      } else if (this.estatusView == true && this.back == true) {
        this.$store.commit("statusViewVisible", false);
        this.estatusView = false;
      }
      this.showButtonToTable = true;
    },
    ButtonToTable() {
      this.showButtonToTable = false;
      if (this.back == false) {
        this.vehiclesView = true;
      } else if (
        this.reportCardOpen == true &&
        this.estatusView == false &&
        this.back == true
      ) {
        this.$store.commit("statusViewVisible", true);
        this.estatusView = true;
      } else if (
        this.reportCardOpen == false &&
        this.reportsView == false &&
        this.back == true
      ) {
        this.$store.commit("reportViewVisible", true);
        this.reportsView = true;
        this.reportCardOpen = true;
      }
    },
    tableToButtonR() {
      this.$store.commit("reportViewVisible", false);
      this.reportsView = false;
      this.reportCardOpen = false;
      this.showButtonToTable = true;
    },
    tableToButtonC() {
      this.commandsView = false;
      this.commandsCardOpen = false;
      this.showButtonToTable = true;
    },
    ButtonToTableC() {
      this.showButtonToTable = false;
      this.commandsView = true;
      this.commandsCardOpen = true;
    },

    //Función para obtener referencia o mostrar ubicación en mapa
    async getReference(item) {
      if (item.Address == i18n.t("showReference")) {
        let reference = null;
        this.updateReferenceText(item, i18n.t("loadingLocation"));

        let activityReference = {
          IdReporte: "NA",
          DeviceId: "NA",
          Lat: item.Location.Lat,
          Lon: item.Location.Lon,
          DateTimestamp: item.Timestap
        };

        try {
          reference = await this.$store.dispatch("getReferenceData", activityReference);
        } catch (e) {
          reference = null;
        }

        reference = reference == null ? i18n.t("notAvailable") : reference;
        item.Address = reference;

        this.updateReferenceText(item, reference);

      } else {
        this.activityToMap(item);
      }
    },

    updateReferenceText(item, reference) {
      //como no tenemos IdReporte, se validará coincidencia con fecha y State
      let activity = this.activityList.find(activity => (activity.Timestap === item.Timestap) && (activity.State === item.State));
        if (activity) {
            activity.Address = reference || i18n.t("notAvailable");
        }
    },
    
    activityToMap(item) {
      let validateCoordinates = this.$store.getters.isValidLatLon({ lat: item.Location.Lat, lon: item.Location.Lon });
      if (validateCoordinates) {
        this.$store.dispatch("zoomActivity", item);
      }
      else {
        this.$store.commit("snackbar", {
          snackbar: true,
          text: i18n.t("mapCoordinatesError")
        });
      }
    },

    refresh() {
      // console.log(this.$store.state.refGeo);
      this.$store.state.trackingFirstTime = true;
      this.$store.dispatch("fleetLastPosition");
      if (this.$store.state.circleTracking != null) {
        this.$store.state.circleTracking.setMap(null);
        this.$store.state.circleTracking = null;
        this.$store.state.referencePointMarker.setMap(null);
        this.$store.state.referencePointMarker = [];
        var toolBox = document.getElementById("sliderTracking");
        toolBox.style.display = "none";
        this.$store.state.radiusActive = false;
        this.isDraggable = false;
        this.slider = 150;
        this.$store.state.autocomplete.set('place',null);
      }
    },
    refreshReport() {
      this.$store.commit("initialReport", false);
      this.$store.dispatch("activityOfVehicle", this.$store.state.selectedVeh);
    },
    radius() {
      var circle = null;
      var referencePointMarker = "";
      this.$store.state.markersInRadius = [];
      var trackingList = this.$store.state.trackingList;
      var toolBox = document.getElementById("sliderTracking");
      this.$store.state.givenRadius = 150 * 1000; //se convierten km a m
      if (this.$store.state.SelectedDistance != "Km") {
        //se convierten las mi a m
        this.$store.state.givenRadius = (150 * 1609.344).toFixed(3).replace(/\.000$/, "");
        this.$store.state.givenRadius = parseFloat(this.$store.state.givenRadius);
      }
      //var origin = "../neutrinost/img/images/";
      var origin = "../img/images/";
      referencePointMarker = new google.maps.Marker({
        position: this.$store.state.referencePoint,
        map: this.$store.state.insideTrackingMap,
        icon: {
          url: origin + "referencePoint.png"
        }
      });
      this.$store.state.referencePointMarker = referencePointMarker;
      circle = new google.maps.Circle({
        center: this.$store.state.referencePoint,
        radius: this.$store.state.givenRadius,
        clickable: false,
        map: this.$store.state.insideTrackingMap,
        strokeOpacity: 0.8,
        strokeColor: "#0366fc",
        strokeWeight: 2,
        fillColor: "#0366fc",
        fillOpacity: 0.35
      });
      this.$store.state.circleTracking = circle;
      for (var i = 0; i < trackingList.length; i++) {
        //la api de google maps calcula la distancia en metros
        if (
          google.maps.geometry.spherical.computeDistanceBetween(
            this.$store.state.referencePoint,
            new google.maps.LatLng(
              trackingList[i].Location.Lat,
              trackingList[i].Location.Lon
            )
          ) <= this.$store.state.givenRadius
        ) {
          this.$store.state.markersInRadius.push(trackingList[i]);
        }
      }
      //obtengo coordenadas a partir de las coordenadas del referencePoint, los metros del radio y a 180 grados 
      //ya que google maps cuenta los grados como el reloj y ocupo 180 grados para ubicarme debajo del circulo
      var newlatLng = google.maps.geometry.spherical.computeOffset(this.$store.state.referencePoint,this.$store.state.givenRadius,180);
      //creo overlay para obtener los pixeles a partir de coordenadas
      // if (this.$store.state.overlayToolBox == null) {
        this.$store.state.overlayToolBox = new google.maps.OverlayView();
        this.$store.state.overlayToolBox.draw = function() {};
        this.$store.state.overlayToolBox.setMap(this.$store.state.insideTrackingMap);
      // }
      var myPixels = this.$store.state.overlayToolBox.getProjection().fromLatLngToContainerPixel(newlatLng);
      //acomodo la toolbox
      toolBox.style.left = myPixels.x + "px";
      toolBox.style.top = myPixels.y + 20 + "px";
      toolBox.style.display = "block";
      
      this.$store.dispatch("setTrackingMap", {
        listOfVeh: this.$store.state.markersInRadius,
        isRadius: true
      });
      this.$store.state.radiusActive = true;
      document.getElementById("menuSearchVehT").style.display = "none";
      document.getElementById("menuTracking").style.display = "none";
    },
    draggableClicked() {
      this.isDraggable = true;
    },
    dragToolBox: function() {
      draggable(document.getElementById("sliderTracking"));
      function draggable(elmnt) {
        var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
        document.getElementById("divDraggable").onmousedown = dragMouseDown;

        function dragMouseDown(e) {
          e = e || window.event;
          e.preventDefault();
          // get the mouse cursor position at startup:
          pos3 = e.clientX;
          pos4 = e.clientY;
          document.onmouseup = closeDragElement;
          // call a function whenever the cursor moves:
          document.onmousemove = elementDrag;
        }

        function elementDrag(e) {
          e = e || window.event;
          e.preventDefault();
          // calculate the new cursor position:
          pos1 = pos3 - e.clientX;
          pos2 = pos4 - e.clientY;
          pos3 = e.clientX;
          pos4 = e.clientY;
          // set the element's new position:
          elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
          elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
        }

        function closeDragElement() {
          /* stop moving when mouse button is released:*/
          document.onmouseup = null;
          document.onmousemove = null;
        }
      }
    }
  }
};
</script>

<style>
/* #searchInput {
  background-color: #fff;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 300;
  margin-left: 12px;
  padding: 0 11px 0 13px;
  text-overflow: ellipsis;
  width: 400px;
} */
.label {
  background-color: #8cd503;
  border: 1px solid black !important;
  color: Black;
  text-align: center;
  white-space: nowrap;
}
.labelPolyline {
  background-color: #fff;
  border: 1px solid black !important;
  color: Black;
  text-align: center;
  white-space: nowrap;
}
/* div.v-application--wrap {
  min-height: 90vh !important;
} */
.line {
  width: 60px;
  height: 5px;
  background: #c4c4c4;
  border-radius: 5px;
  position: relative;
  margin: 0 auto;
  clear: left;
  z-index: 0;
  text-align: center;
  cursor: pointer;
}
.tableTracking > .v-data-table__wrapper > table > tbody > tr :hover {
  cursor: pointer;
}
.tableTracking.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.03);
  color: black;
}
.tableTracking.theme--dark.v-data-table tbody tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
}
#menuTracking {
  position: absolute;
  z-index: 7;
  width: 180px;
  display: none;
  border-radius: 5px;
  box-shadow: 2px 2px 30px lightgrey;
}
#menuTracking ul {
  padding-left: 0px !important;
}
#menuTracking ul li {
  list-style-type: none;
  margin: 0;
  padding: 0;
  float: left;
}
.menu-item {
  padding: 3px 0px 3px 0px;
  margin-bottom: 0px !important;
}
.menu-item:hover {
  background-color: #eee;
  cursor: pointer;
}
#sizeChev {
  font-size: 30px;
}
.brT {
  display: block;
  content: "";
  margin-top: 0;
}
.theScrollTracking {
  overflow-y: auto;
  overflow-x: hidden;
}
.heightOfTrackingCard {
  height: 100% !important;
}
#trackingMap > div {
  top: 15px !important;
}
.btnSelectDistanceT {
  text-transform: unset !important;
}
#menuSearchVehT {
  position: absolute;
  z-index: 7;
  width: 180px;
  display: none;
  border-radius: 5px;
  box-shadow: 2px 2px 30px lightgrey;
}
#sliderTracking {
  position: absolute;
  z-index: 7;
  width: 180px;
  display: none;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 2px 2px 30px lightgrey;
}
</style>